import React, { Children, useEffect } from "react"
import PropTypes from "prop-types"
import { createStructuredSelector } from "reselect"
import { connect } from "react-redux"
import { compose } from "redux"
import { map } from "lodash"
// Selectors
import { selectSideMenuColor } from "Containers/BusinessInformations/selectors"
import { selectCurrentToken, selectCurrentUser } from "Containers/Login/selectors"
import { selectActualityList } from "ContainersForm/DocumentManagement/selectors"
// Actions
import { getActualityAction } from "ContainersForm/DocumentManagement/actions"
import { downloadFileEtlAction } from "ContainersForm/ETL/actions.js"
// Style
import {
  ContainerActuality,
  Row,
  Title,
  Description,
  FileList,
  File,
} from "Components/chartsLibrary/ActualityList/index.style"

const ActualityList = ({
  //props
  sideMenuColor,
  actualityList,
  // func
  getActuality,
  downloadFile,
}) => {
  useEffect(() => {
    getActuality()
  }, [])
  // function
  const onClickDownloadFile = file => {
    downloadFile({ fileName: file?.name })
  }

  const data = actualityList

  return (
    <ContainerActuality>
      {Children.toArray(
        map(data, row => {
          return (
            <Row>
              <Title>{row?.title}</Title>
              <Description dangerouslySetInnerHTML={{ __html: row?.content }} />
              <FileList>
                {Children.toArray(
                  map(row?.filesAttachedIds, file => {
                    const nameFile = file?.name?.slice(36)
                    return (
                      <File color={sideMenuColor} onClick={() => onClickDownloadFile(file)}>
                        <i className="fas fa-upload downloadFile" />
                        <p title={nameFile}>{nameFile}</p>
                      </File>
                    )
                  })
                )}
              </FileList>
            </Row>
          )
        })
      )}
    </ContainerActuality>
  )
}

ActualityList.propTypes = {}

ActualityList.defaultProps = {}

const mapDispatchToProps = dispatch => ({
  downloadFile: payload => dispatch(downloadFileEtlAction(payload)),
  getActuality: payload => dispatch(getActualityAction(payload)),
})

const mapStateToProps = createStructuredSelector({
  sideMenuColor: selectSideMenuColor,
  currentToken: selectCurrentToken,
  currentUser: selectCurrentUser,
  actualityList: selectActualityList,
})

export default compose(connect(mapStateToProps, mapDispatchToProps))(ActualityList)
